module.exports = __webpack_public_path__ + "img/img_two_map_retail@3x.583daf02.png";